import apiClient from '../client';

class ConsentService {
    getPlatformTitle = (data,token)=> apiClient().post('/consent/platform/title',data,{headers:{
        'x-access-token':token
    }});
    
    getPlatformTabs=(token)=> apiClient().post('/consent/plartform/tabs/all',{},{headers:{
        'x-access-token':token
    }});

}

export default new ConsentService();